"use client";

import { ArrowTopRightOnSquare } from "@/components/atom/mark/arrowTopRightOnSquare";
import { SubTitle } from "@/components/moleculer/events/suzuka2024/subTitle";

const CompanyCard = (props: {
	name: string;
	imgPath: string;
	alt: string;
	hasPadding?: boolean;
	url: string;
}) => {
	return (
		<div className={"flex-col flex"}>
			<img
				src={props.imgPath}
				className={`w-80 h-auto ${props.hasPadding && "p-16"}`}
				alt={props.alt}
			/>
			<button
				type="button"
				className={"flex hover:cursor-pointer hover:underline"}
				onClick={(): void => {
					window.open(props.url);
				}}
			>
				<p>{props.name}</p>
				<ArrowTopRightOnSquare />
			</button>
		</div>
	);
};
export const Companies = () => {
	const className = "flex flex-col gap-4";
	return (
		<div className={"flex flex-col gap-8"}>
			<div className={className}>
				<SubTitle title={"主催"} />
				<CompanyCard
					name={"独立行政法人国立高等専門学校機構 鈴鹿工業高等専門学校"}
					imgPath={"/png/kosen/suzuka.jpeg"}
					alt={"鈴鹿高専ロゴ"}
					url={"https://www.suzuka-ct.ac.jp/"}
					hasPadding
				/>
			</div>
			<div className={className}>
				<SubTitle title={"協賛"} />
				<CompanyCard
					name={"株式会社うるる"}
					imgPath={"/events/suzuka2024/uluru.png"}
					alt={"株式会社うるるロゴ"}
					url={"https://www.uluru.biz/"}
				/>
			</div>
			<div className={className}>
				<SubTitle title={"運営"} />
				<CompanyCard
					name={"株式会社プロッセル"}
					imgPath={"/events/suzuka2024/prossell.webp"}
					alt={"株式会社プロッセルロゴ"}
					url={"https://prossell.jp/"}
					hasPadding
				/>
			</div>
		</div>
	);
};
